import { Badge, IconButton, Menu, alpha, styled } from '@mui/material';

export const CartIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.text.primary, 0.04),
  borderRadius: '14px',
  transition: 'background-color 120ms ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.08),
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiMenu-paper': {
    width: '22rem',
    maxHeight: '80%',
    marginTop: '8px',
    borderRadius: '14px',
    border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

export const EmptyCartMessage = styled('div')(({ theme }) => ({
  padding: '24px 16px',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  fontSize: '13px',
}));
